import { api } from "@/lib/api";

import type {
  NumberSequence,
  NumberSequenceSummary,
  ResetNumberSequenceReq,
  UpdateNumberSequenceReq,
} from "@artisancode/api-types";

export const numberSequenceService = {
  list: (workspaceId?: string) =>
    api.get<NumberSequenceSummary[]>("/number-sequences", {
      workspace_id: workspaceId || undefined,
    }),

  getByModuleCode: (moduleCode: string, workspaceId?: string) =>
    api.get<NumberSequence>(`/number-sequences/${moduleCode}`, {
      workspace_id: workspaceId || undefined,
    }),

  update: (
    moduleCode: string,
    body: UpdateNumberSequenceReq,
    workspaceId?: string,
  ) =>
    api.put<NumberSequence>(`/number-sequences/${moduleCode}`, {
      ...body,
      workspace_id: workspaceId || undefined,
    }),

  reset: (
    moduleCode: string,
    body?: ResetNumberSequenceReq,
    workspaceId?: string,
  ) =>
    api.post<NumberSequence>(`/number-sequences/${moduleCode}/reset`, {
      ...(body ?? {}),
      workspace_id: workspaceId || undefined,
    }),
};
